export default () => {
  const el = document.querySelector(".js-promo-bar") as HTMLElement;

  if (!el) {
    return;
  }

  let close = el.querySelector(".js-close") as HTMLElement;

  const showPromoBar = () => {
    el.classList.remove("is-hidden");

    document.body.classList.add("has-promo-bar");
  };

  const disablePromoBar = () => {
    // if a user closes the promo bar, give them 24 hours before showing it again
    window.sessionStorage.setItem(
      "closedPromos",
      (new Date().getTime() + 86400000).toString()
    );
    el.classList.add("is-hidden");
    document.body.classList.remove("has-promo-bar");
  };

  const parseEndDate = (raw: string): Date | null => {
    if (!raw) {
      return null;
    }
    const trimmed = raw.trim();
    // Safari won't parse "YYYY-MM-DD HH:MM"; normalise the space to a T.
    let date = new Date(trimmed.replace(" ", "T"));
    if (isNaN(date.getTime())) {
      date = new Date(trimmed);
    }
    return isNaN(date.getTime()) ? null : date;
  };

  const initCountdown = () => {
    // The countdown is repeated once per marquee group, so update them all.
    const timers = Array.from(
      el.querySelectorAll(".js-promo-countdown")
    ) as HTMLElement[];
    if (timers.length === 0) {
      return;
    }

    const end = parseEndDate(timers[0].getAttribute("data-countdown-end") || "");

    // Remove every countdown entry (and its trailing heart separator) so an
    // elapsed/invalid timer leaves the marquee clean.
    const removeCountdowns = () => {
      timers.forEach((timer) => {
        const item = timer.closest(
          ".promo-bar__text--countdown"
        ) as HTMLElement | null;
        const heart = item?.nextElementSibling;
        if (heart && heart.classList.contains("fa-heart")) {
          heart.remove();
        }
        if (item) {
          item.remove();
        }
      });
    };

    if (!end || end.getTime() - Date.now() <= 0) {
      removeCountdowns();
      return;
    }

    const pad = (n: number) => String(n).padStart(2, "0");

    let interval: ReturnType<typeof setInterval> | null = null;

    const tick = () => {
      const diff = end.getTime() - Date.now();

      if (diff <= 0) {
        if (interval) {
          clearInterval(interval);
        }
        removeCountdowns();
        return;
      }

      const totalSeconds = Math.floor(diff / 1000);
      const days = pad(Math.floor(totalSeconds / 86400));
      const hours = pad(Math.floor((totalSeconds % 86400) / 3600));
      const mins = pad(Math.floor((totalSeconds % 3600) / 60));
      const secs = pad(totalSeconds % 60);

      timers.forEach((timer) => {
        const daysEl = timer.querySelector(".js-cd-days");
        const hoursEl = timer.querySelector(".js-cd-hours");
        const minsEl = timer.querySelector(".js-cd-mins");
        const secsEl = timer.querySelector(".js-cd-secs");
        if (daysEl) daysEl.textContent = days;
        if (hoursEl) hoursEl.textContent = hours;
        if (minsEl) minsEl.textContent = mins;
        if (secsEl) secsEl.textContent = secs;
      });
    };

    tick();
    interval = setInterval(tick, 1000);
  };

  // check to make sure its not already closed
  let closed = window.sessionStorage.getItem("closedPromos");

  if (!closed || parseInt(closed) < new Date().getTime()) {
    showPromoBar();

    // Start the countdown before querying slides so an elapsed/invalid one is
    // removed and the rotation count stays accurate.
    initCountdown();

    let i = 0;
    let interval: any = null;

    const rotate = () => {
      i++;
      if (i >= contents.length) {
        i = 0;
      }
      contents.forEach((content, index) => {
        if (index === i) {
          content.classList.remove("is-hidden");
        } else {
          content.classList.add("is-hidden");
        }
      });
    };

    // if hovering over the promo bar, pause the rotation
    el.addEventListener("mouseenter", () => {
      if (interval) {
        clearInterval(interval);
      }
    });

    el.addEventListener("mouseleave", () => {
      interval = setInterval(rotate, 4000);
    });

    // if more that 1 .promo-bar__content elements within the promo bar, show the next one
    // every 4 seconds
    let contents = Array.from(el.querySelectorAll(".promo-bar__content"));
    if (contents.length > 1) {
      interval = setInterval(rotate, 4000);
    }
  }

  if (close) {
    close.addEventListener("click", () => {
      disablePromoBar();
    });
  }
};
